import { useMemo, useRef, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { FaSearch, FaTimes } from "react-icons/fa";

export default function SearchQueryInput({
    defaultValue = "",
    placeholder,
    onValueChange,
    onEnter,
    className,
}) {
    const [value, setValue] = useState(defaultValue);
    const inputRef = useRef(null);

    const clear = () => {
        setValue("");
        onValueChange?.("");
        inputRef.current?.focus();
    };

    const handleChange = (e) => {
        const next = e.target.value;
        setValue(next);
        onValueChange?.(next);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            onEnter?.(value);
        }
    };

    const ariaLabel = useMemo(() => placeholder ?? "Search", [placeholder]);

    return (
        <InputGroup className={className}>
            <Form.Control
                ref={inputRef}
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                aria-label={ariaLabel}
            />

            {value && (
                <Button
                    type="button"
                    variant="outline-secondary"
                    className="border-secondary-subtle"
                    onClick={clear}
                    aria-label="Clear search"
                >
                    <FaTimes aria-hidden="true" focusable="false" />
                </Button>
            )}

            <InputGroup.Text aria-hidden="true">
                <FaSearch focusable="false" />
            </InputGroup.Text>
        </InputGroup>
    );
}
